export default {
  name: 'contact',

  ui: {
    object1: '[js-contact-object1]',
    object2: '[js-contact-object2]',
    object3: '[js-contact-object3]',
    trainingRef: '[js-contact-training-ref]',
  },

  events: [
    {
      on: 'change',
      target: 'object1',
      handle (e) {
        if (e.target.value === 'training') {
          this.ui.object2.closest('.contact-select').classList.remove('hidden')
          this.ui.object2.setAttribute('required', true)
        } else {
          this.ui.object2.closest('.contact-select').classList.add('hidden')
          this.ui.object3.closest('.contact-select').classList.add('hidden')
          this.ui.object2.removeAttribute('required')
          this.ui.object3.removeAttribute('required')

          this.ui.trainingRef.value = null
          this.ui.trainingRef.classList.add('hidden')

          this.resetSelect(this.ui.object2)
          this.resetSelect(this.ui.object3)
        }
      },
    },
    {
      on: 'change',
      target: 'object2',
      handle (e) {
        if (e.target.value === 'catalog') {
          this.ui.object3.setAttribute('required', true)
          this.ui.object3.closest('.contact-select').classList.remove('hidden')
        } else {
          this.ui.object3.closest('.contact-select').classList.add('hidden')
          this.ui.object3.removeAttribute('required')
          this.resetSelect(this.ui.object3.closest('.contact-select'))
        }

        if (e.target.value === 'catalog' || e.target.value === 'training-perso') {
          this.ui.trainingRef.classList.remove('hidden')
        } else {
          this.ui.trainingRef.classList.add('hidden')
          this.ui.trainingRef.value = null
        }
      },
    },
  ],

  resetSelect (select) {
    select.closest('.contact-select').querySelector('.custom-select-option').click()
    select.value = ''
  },

  componentDidMount () {
    const urlParams = new URLSearchParams(window.location.search)
    const subject = urlParams.get('subject')

    if (subject) {
      this.ui.object1.value = subject

      // trick for desktop not working with only first instruction
      this.ui.object1.closest('.contact-select').querySelectorAll('.custom-select-option').forEach(option => {
        if (option.dataset.value === subject) {
          option.click()
        }
      })
    }
  },
}
